/* global $ */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import axiosInstance from '../axiosInstance';

function Stocks() {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [newRecord, setNewRecord] = useState({
        date: "",
        amount: "",
        description: "",
    });

    const [errors, setErrors] = useState({
        date: "",
        amount: "",
        description: "",
    });

    const handleClear = () => {
        setData([]);
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`/stocks/list`);
            console.log(response.data)
            setData(response.data.data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecord(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors        

        // Log the values for debugging
        //console.log('Date:', newRecord.date);

        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!newRecord.date) {
            formErrors.date = "Date is required";
        }

        if (!newRecord.amount) {
            formErrors.amount = "Amount is required";
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    const handleAddService = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Add Service Charges?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });

        if (result.isConfirmed) {
            setSelectedRow(row);

            $('#addserviceRowModal').modal('show');
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const created_by = localStorage.getItem('user_id')
        let dealerId = "";
        if (validateForm()) {
            setErrors({});
            try {

                // Proceed with form submission (API call or other actions)
                //console.log("Form submitted", newRecord);
                const newRecordData = {
                    dealer_id: selectedRow.dealer.id,
                    reg_no: selectedRow.dealer.reg_no,
                    date: newRecord.date,
                    amount: newRecord.amount,
                    description: newRecord.description,
                    created_by: created_by,

                };

                try {
                    const response = await axiosInstance.post('/servicefee/add', newRecordData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });

                    dealerId = response.data.dealer_id;

                    await Swal.fire('Created!', 'The Service Charge record has been Created.', 'success');
                } catch (error) {
                    console.error('Error creating new record:', error);
                    // Extract error message from API response
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Get error message from backend response
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorMessage,
                    });
                }

                $('#addserviceRowModal').modal('hide').on('hidden.bs.modal', function () {
                    // Ensure backdrop is removed correctly by Bootstrap
                    setTimeout(() => {
                        $('body').removeClass('modal-open');// Ensure body class is reset
                        $('.modal-backdrop').remove();
                        $('body').css('padding-right', ''); // Reset any padding added by Bootstrap to compensate for scrollbar

                        // Re-enable scrolling
                        $('body').css('overflow', '');
                    }, 500); // Wait for a short time to let Bootstrap handle transitions
                });
                fetchData();
                setNewRecord({
                    date: "",
                    amount: "",
                    description: "",
                });
            }
            catch (error) {
                console.error('Error saving File:', error);
                // Extract error message from API response
                let errorMessage = 'There was an issue in saving the record.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message; // Get error message from backend response
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error saving File!',
                    text: errorMessage,
                });
            }
        }
    }

    // Clear the date fields when the modal is closed
    $('#addserviceRowModal').on('hidden.bs.modal', function () {
        // Clear the date picker values
        $('#date').datetimepicker('clear');

        // Reset the form state
        setNewRecord({
            date: "",
            amount: "",
            description: "",
        });
    });

    const printBill = async (row) => {
        setSelectedRow(row);
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });
        if (result.isConfirmed) {
            const printContents = document.getElementById("download_section").innerHTML;
            const originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;  // Replace body content with invoice
            window.print();  // Trigger the print dialog
            document.body.innerHTML = originalContents;
            window.location.reload(); // Ensure styles and scripts are reapplied
        }
    };

    const handleView = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to View Service Charge details?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });

        if (result.isConfirmed) {
            setSelectedRow(row);

            $('#viewserviceRowModal').modal('show');
        }
    };

    const handleDealerView = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to View Bike details?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });

        if (result.isConfirmed) {
            setSelectedRow(row);

            $('#viewdealerRowModal').modal('show');
        }
    };

    const filteredData = data.filter(item =>
        String(item.dealer.reg_no || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (item.dealer?.model || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (item.dealer?.color || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (item.dealer?.make_year || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (item.dealer?.buyprice || '').toLowerCase().includes(searchText.toLowerCase())
    );




    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.dealer.reg_no || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Model</span>,
            selector: row => row.dealer?.model || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Color</span>,
            selector: row => row.dealer?.color || "",
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Make Year</span>,
            selector: row => row.dealer?.make_year || "",
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Buy Price</span>,
            selector: row => row.dealer?.buy_price || "",
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Service Charge</span>,
            selector: row => row.dealer?.total_service_amount || "",
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Total</span>,
            selector: row => row.dealer?.total_price || "",
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleAddService(row)} className="btn btn-info btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-plus"></i>
                    </button>
                    <button onClick={() => handleView(row)} className="btn btn-success btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-eye"></i>
                    </button>
                    <button onClick={() => handleDealerView(row)} className="btn btn-primary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-motorcycle"></i>
                    </button>
                </div>
            ),
            width: '250px'
        }
    ];


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Stock Details</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Stock Details</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>


            {data && (
                <div className="row mb-2 mt-2">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={20}  // Set number of rows per page
                                    paginationRowsPerPageOptions={[20, 50, 100, 150, 200, 250, 300, 350, 400]}
                                />

                                {/* Add Service Charge */}
                                <div className="modal fade" id="addserviceRowModal" tabIndex="-1" role="dialog" aria-labelledby="addServiceLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary text-white">
                                                <h5 className="modal-title" id="addServiceLabel">
                                                    <i className="fas fa-plus-circle mr-2"></i>Add Service Charge
                                                </h5>
                                                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>

                                            <form onSubmit={handleSubmit}>
                                                <div className="modal-body">
                                                    <div className="form-group">
                                                        <label><i className="far fa-calendar-alt mr-1"></i>Date</label>
                                                        <input
                                                            id="date"
                                                            type="date"
                                                            value={newRecord.date || ''}
                                                            onChange={(e) => setNewRecord(prev => ({ ...prev, date: e.target.value }))}
                                                            className="form-control"
                                                        />
                                                        {errors.date && <small className="text-danger">{errors.date}</small>}
                                                    </div>

                                                    <div className="form-group">
                                                        <label><i className="fas fa-rupee-sign mr-1"></i>Amount</label>
                                                        <input
                                                            type="text"
                                                            name="amount"
                                                            value={newRecord.amount}
                                                            onChange={handleInputChange}
                                                            className="form-control"
                                                            placeholder="Enter amount"
                                                        />
                                                        {errors.amount && <small className="text-danger">{errors.amount}</small>}
                                                    </div>

                                                    <div className="form-group">
                                                        <label><i className="fas fa-align-left mr-1"></i>Description</label>
                                                        <textarea
                                                            name="description"
                                                            value={newRecord.description}
                                                            onChange={handleInputChange}
                                                            className="form-control"
                                                            rows="3"
                                                            placeholder="Write short description"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="modal-footer justify-content-between">
                                                    <button type="submit" className="btn btn-success">
                                                        <i className="fas fa-save mr-1"></i>Save Changes
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>


                                {/* View Service Charge Modal */}
                                <div className="modal fade" id="viewserviceRowModal" tabIndex="-1" role="dialog" aria-labelledby="viewServiceLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-info text-white">
                                                <h5 className="modal-title" id="viewServiceLabel">
                                                    <i className="fas fa-list-alt mr-2"></i>Service Charge Details
                                                </h5>
                                                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>

                                            <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                                {selectedRow && selectedRow.services && selectedRow.services.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped table-sm">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th style={{ width: '5%' }}>#</th>
                                                                    <th style={{ width: '20%' }}>Date</th>
                                                                    <th>Registration No</th>
                                                                    <th>Description</th>
                                                                    <th>Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {selectedRow.services.map((service, index) => (
                                                                    <tr key={service.id}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{service.date}</td>
                                                                        <td>{service.reg_no}</td>
                                                                        <td>{service.description}</td>
                                                                        <td>₹ {service.amount}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="alert alert-warning text-center">
                                                        <i className="fas fa-exclamation-triangle mr-2"></i>No service records found.
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* View Dealer Modal */}
                                <div className="modal fade" id="viewdealerRowModal" tabIndex="-1" role="dialog" aria-labelledby="viewDealerLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header bg-secondary text-white">
                                                <h5 className="modal-title" id="viewDealerLabel">
                                                    <i className="fas fa-id-card-alt mr-2"></i>Dealer Details
                                                </h5>
                                                <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>

                                            <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                                {selectedRow && selectedRow.dealer && Object.keys(selectedRow.dealer).length > 0 ? (
                                                    <div className="container-fluid">
                                                        <div className="row mb-3">
                                                            <div className="col-sm-6">
                                                                <p><strong><i className="far fa-calendar-alt mr-1"></i>Date:</strong> {selectedRow.dealer.date || ''}</p>
                                                            </div>
                                                            <div className="col-sm-6 text-right">
                                                                <h5><strong>{selectedRow.dealer.reg_no || ''}</strong></h5>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <h6 className="text-primary"><i className="fas fa-car-side mr-1"></i>Vehicle Details</h6>
                                                                <p><strong>Registration No:</strong> {selectedRow.dealer.reg_no || ''}</p>
                                                                <p><strong>Vehicle Name:</strong> {selectedRow.dealer.vehicle_name || ''}</p>
                                                                <p><strong>Model:</strong> {selectedRow.dealer.model || ''}</p>
                                                                <p><strong>Make Year:</strong> {selectedRow.dealer.make_year || ''}</p>
                                                                <p><strong>Color:</strong> {selectedRow.dealer.color || ''}</p>
                                                                <p><strong>Fuel Type:</strong> {selectedRow.dealer.fuel_type || ''}</p>
                                                                <p><strong>Chassis No:</strong> {selectedRow.dealer.chase_no || ''}</p>
                                                                <p><strong>Engine No:</strong> {selectedRow.dealer.engine_no || ''}</p>
                                                                <p><strong>Number Of Owners:</strong> {selectedRow.dealer.noofowners || ''}</p>
                                                                <p><strong>Buy Price:</strong> {selectedRow.dealer.buy_price ? `₹${selectedRow.dealer.buy_price}` : ''}</p>
                                                                <p><strong>Sell Price:</strong> {selectedRow.dealer.sell_price ? `₹${selectedRow.dealer.sell_price}` : ''}</p>
                                                            </div>

                                                            <div className="col-md-6 mb-3">
                                                                <h6 className="text-primary"><i className="fas fa-id-card mr-1"></i>Registration Details</h6>
                                                                <p><strong>Reg Date:</strong> {selectedRow.dealer.reg_date ? new Date(selectedRow.dealer.reg_date).toLocaleDateString('en-GB') : ''}</p>
                                                                <p><strong>Reg Valid Upto:</strong> {selectedRow.dealer.reg_valid_upto ? new Date(selectedRow.dealer.reg_valid_upto).toLocaleDateString('en-GB') : ''}</p>
                                                                <p><strong>Endos:</strong> {selectedRow.dealer.endos || ''}</p>
                                                                <p><strong>Endos in RC:</strong> {selectedRow.dealer.endosinrc ? 'Yes' : 'No'}</p>
                                                                <hr />
                                                                <h6 className="text-primary"><i className="fas fa-user-tie mr-1"></i>Dealer Info</h6>
                                                                <p><strong>Name:</strong> {selectedRow.dealer.dealer_name || ''}</p>
                                                                <p><strong>Address 1:</strong> {selectedRow.dealer.dealer_address1 || ''}</p>
                                                                <p><strong>Address 2:</strong> {selectedRow.dealer.dealer_address2 || ''}</p>
                                                                <p><strong>Address 3:</strong> {selectedRow.dealer.dealer_address3 || ''}</p>
                                                                <p><strong>City:</strong> {selectedRow.dealer.dealer_city || ''}</p>
                                                                <p><strong>Primary Phone:</strong> {selectedRow.dealer.dealer_phone1 || ''}</p>
                                                                <p><strong>Secondary Phone:</strong> {selectedRow.dealer.dealer_phone2 || ''}</p>
                                                            </div>
                                                        </div>

                                                        {/* RC Owner Details */}
                                                        {(selectedRow.dealer.rcowner_name || selectedRow.dealer.rcowner_pan || selectedRow.dealer.rcowner_aadhaar) && (
                                                            <div className="row">
                                                                <div className="col-12 mb-3">
                                                                    <h6 className="text-primary"><i className="fas fa-user-check mr-1"></i>RC Owner Details</h6>
                                                                    <div className="row">
                                                                        <div className="col-md-4"><p><strong>RC Owner Name:</strong> {selectedRow.dealer.rcowner_name || ''}</p></div>
                                                                        <div className="col-md-4"><p><strong>RC Owner PAN:</strong> {selectedRow.dealer.rcowner_pan || ''}</p></div>
                                                                        <div className="col-md-4"><p><strong>RC Owner Aadhaar:</strong> {selectedRow.dealer.rcowner_aadhaar || ''}</p></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Insurance Details */}
                                                        {(selectedRow.dealer.insurance || selectedRow.dealer.insurance_upto) && (
                                                            <div className="row">
                                                                <div className="col-12 mb-3">
                                                                    <h6 className="text-primary"><i className="fas fa-shield-alt mr-1"></i>Insurance</h6>
                                                                    <div className="row">
                                                                        <div className="col-md-4"><p><strong>Insurance Company:</strong> {selectedRow.dealer.insurance || ''}</p></div>
                                                                        <div className="col-md-4"><p><strong>Insurance Upto:</strong> {selectedRow.dealer.insurance_upto ? new Date(selectedRow.dealer.insurance_upto).toLocaleDateString('en-GB') : ''}</p></div>
                                                                        <div className="col-md-4"><p><strong>Financier:</strong> {selectedRow.dealer.financier || ''}</p></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Financial & Transfer */}
                                                        {(selectedRow.dealer.nametransferto || selectedRow.dealer.finance_amount) && (
                                                            <div className="row">
                                                                <div className="col-12 mb-3">
                                                                    <h6 className="text-primary"><i className="fas fa-exchange-alt mr-1"></i>Financial & Transfer</h6>
                                                                    <div className="row">
                                                                        <div className="col-md-4"><p><strong>Finance Amount:</strong> {selectedRow.dealer.finance_amount ? `₹${selectedRow.dealer.finance_amount}` : ''}</p></div>
                                                                        <div className="col-md-4"><p><strong>Transfer To:</strong> {selectedRow.dealer.nametransferto || ''}</p></div>
                                                                        <div className="col-md-4"><p><strong>Transfer Holding:</strong> {selectedRow.dealer.nametransferholdingamount ? `₹${selectedRow.dealer.nametransferholdingamount}` : ''}</p></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Bike Photos */}
                                                        {(() => {
                                                            const d = selectedRow.dealer;
                                                            const photos = [
                                                                d.files?.bike_photo_1?.url || d.files?.bikePhotos?.[0]?.url,
                                                                d.files?.bike_photo_2?.url || d.files?.bikePhotos?.[1]?.url,
                                                                d.files?.bike_photo_3?.url || d.files?.bikePhotos?.[2]?.url,
                                                                d.files?.bike_photo_4?.url || d.files?.bikePhotos?.[3]?.url,
                                                            ].filter(Boolean);
                                                            return photos.length > 0 ? (
                                                                <div className="row">
                                                                    <div className="col-12 mb-3">
                                                                        <h6 className="text-primary"><i className="fas fa-images mr-1"></i>Bike Photos</h6>
                                                                        <div className="row">
                                                                            {photos.map((url, i) => (
                                                                                <div className="col-6 col-md-3 mb-2" key={i}>
                                                                                    <a href={url} target="_blank" rel="noreferrer">
                                                                                        <img src={url} alt={`Bike ${i + 1}`} className="img-fluid img-thumbnail" style={{ maxHeight: '120px', objectFit: 'cover' }} />
                                                                                    </a>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : null;
                                                        })()}

                                                        {selectedRow.dealer.note && (
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="alert alert-light border shadow-sm">
                                                                        <strong>Note:</strong> {selectedRow.dealer.note}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="alert alert-warning text-center">
                                                        <i className="fas fa-exclamation-triangle mr-2"></i>No Dealer Data Available
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-xl">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Bill</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                {/* School Fee Bill */}
                                                {selectedRow && selectedRow.billing_details && Object.keys(selectedRow.billing_details).length > 0 && (
                                                    <div className="delivery-note-container">
                                                        <div className="delivery-note-header">
                                                            <img src="dist/img/5.png" alt="Shivam Moto Banner" className="header-image" />
                                                        </div>

                                                        <div className="delivery-note-section">
                                                            {/* Left Section for DN No. and Date */}
                                                            <div className="delivery-note-left">
                                                                <p><strong>Bill No:</strong>{selectedRow.billing_id || ""}</p>
                                                                <p><strong>Date:</strong>{selectedRow.billing_details.date || ""}</p>
                                                            </div>

                                                            <div className="delivery-note-header">
                                                                <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                                                                <h3 className="delivery-note-title1">ONLY ON COMMISSION BASIS</h3>
                                                            </div>


                                                            {/* Right Section for Image */}
                                                            <div className="delivery-note-image">
                                                                <div className="delivery-note-image-container">
                                                                    <img src={selectedRow?.files?.photo_file?.url || ""} alt="Buyer" className="fixed-image" />
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div className="delivery-note-info">
                                                            <div>
                                                                <h3 className="delivery-note-fromto"><span className="highlight-text">Buyer</span>:</h3>
                                                                <p>{selectedRow.billing_details.from_name || ""}</p>
                                                                <p>{selectedRow.billing_details.from_address1 || ""}</p>
                                                                <p>{selectedRow.billing_details.from_address2 || ""}</p>
                                                                <p>{selectedRow.billing_details.from_city || ""}</p>
                                                                <p>
                                                                    <strong>Phone:</strong> {selectedRow.billing_details.from_phone1}, {selectedRow.billing_details.from_phone2}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3 className="delivery-note-fromto"><span className="highlight-text">Seller</span>:</h3>
                                                                <p>{selectedRow.billing_details.to_name}</p>
                                                                <p>{selectedRow.billing_details.to_address1}</p>
                                                                <p>{selectedRow.billing_details.to_address2}</p>
                                                                <p>{selectedRow.billing_details.to_city}</p>
                                                                <p>
                                                                    <strong>Phone:</strong> {selectedRow.billing_details.to_phone1}, {selectedRow.billing_details.to_phone2}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="delivery-note-right-align">
                                                            <p><strong>Sir,</strong></p>
                                                            <div className="letter-content">
                                                                <p><span className="highlight-text"><strong>Ref:</strong> {selectedRow.ref_reg_no} / {selectedRow.billing_details.ref_vehicle_type} {selectedRow.billing_details.ref_vehicle_color}</span></p>
                                                                <p>
                                                                    I have this day purchased the above vehicle from you for the sum of Rs.<strong> {selectedRow.billing_details.ref_amount}</strong> (Rupees in Words: <strong> {selectedRow.billing_details.ref_amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                                                </p>
                                                                <p>
                                                                    The entire risk is being bome by me / us / from this time <strong>{selectedRow.billing_details.ref_time}</strong>
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="delivery-note-row">
                                                            {/* Left: Vehicle Details */}
                                                            <div className="delivery-note-vehicle-details">
                                                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark></h3>
                                                                <p><strong>Model:</strong><span>{selectedRow.billing_details.bike_model}</span></p>
                                                                <p><strong>Make:</strong><span>{selectedRow.billing_details.bike_make}</span></p>
                                                                <p><strong>Color:</strong> <span>{selectedRow.billing_details.bike_color}</span></p>
                                                                <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.bike_chase_no}</span></p>
                                                                <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.bike_engine_no}</span></p>
                                                            </div>

                                                            {/* Right: Payment Details */}
                                                            <div className="delivery-note-payment">
                                                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark></h3>
                                                                <p><strong>1) Payment Type:</strong><span> {selectedRow.billing_details.payment_type1}  /  {selectedRow.billing_details.cash_paid1}</span></p>
                                                                <p><strong>2) Payment Type:</strong><span> {selectedRow.billing_details.payment_type2}  /  {selectedRow.billing_details.cash_paid2}</span></p>
                                                                <p><strong>Finance Details:</strong></p>
                                                                <p><strong>Bank Name:</strong> <span>{selectedRow.billing_details.bank_name}</span></p>
                                                                <p><strong>Finance:</strong><span> {selectedRow.billing_details.finance}</span></p>
                                                            </div>
                                                        </div>
                                                        {/* <h3 className="delivery-note-fromto">Exchange Details</h3>
                                                        <div className="delivery-note-row">

                                                            
                                                            <div className="delivery-note-vehicle-details">
                                                                <p><strong>Exchange Of:</strong><span>{selectedRow.billing_details.exchange_of}</span></p>
                                                                <p><strong>Amount:</strong><span>{selectedRow.billing_details.exchange_amout}</span></p>
                                                                <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.exchange_bike_chase_no}</span></p>
                                                                <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.exchange_bike_engine_no}</span></p>
                                                            </div>

                                                           
                                                            <div className="delivery-note-payment">
                                                                <p><strong>Model:</strong><span>{selectedRow.billing_details.exchange_bike_model}</span></p>
                                                                <p><strong>Reg No:</strong><span>{selectedRow.billing_details.exchange_reg_no}</span></p>
                                                                <p><strong>Make:</strong> <span>{selectedRow.billing_details.exchange_bike_make}</span></p>
                                                                <p><strong>Color:</strong> <span>{selectedRow.billing_details.exchange_bike_color}</span></p>
                                                            </div>
                                                        </div> */}
                                                        <p><mark className="highlight-text"><strong>Received Documents:{" "}
                                                            {[
                                                                selectedRow.billing_details.is_rc && "RC BOOK",
                                                                selectedRow.billing_details.is_insurance && "INSURANCE COPY",
                                                                selectedRow.billing_details.is_form_2930 && "FORM 29 & 30",
                                                                selectedRow.billing_details.is_noc && "NOC"
                                                            ].filter(Boolean).join(", ")}
                                                        </strong></mark></p>
                                                        <div className="delivery-note-tamil-text">
                                                            <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                                                            <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                                                            <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                                                            <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/*Print Bill*/}
            {selectedRow && (
                <div id="download_section" style={{ display: "none" }}>
                    {selectedRow && selectedRow.billing_details && Object.keys(selectedRow.billing_details).length > 0 && (

                        <div className="delivery-note-container">
                            <div className="delivery-note-header">
                                <img src="dist/img/5.png" alt="Shivam Moto Banner" className="header-image" />
                            </div>

                            <div className="delivery-note-section">
                                {/* Left Section for DN No. and Date */}
                                <div className="delivery-note-left">
                                    <p><strong>Bill No:</strong>{selectedRow.billing_id}</p>
                                    <p><strong>Date:</strong>{selectedRow.billing_details.date}</p>
                                </div>

                                <div className="delivery-note-header">
                                    <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                                    <h4 className="delivery-note-title1">ONLY ON COMMISSION BASIS</h4>
                                </div>


                                {/* Right Section for Image */}
                                <div className="delivery-note-image">
                                    <div className="delivery-note-image-container">
                                        <img src={selectedRow?.files?.photo_file?.url || ""} alt="Buyer" className="fixed-image" />
                                    </div>
                                </div>

                            </div>

                            <div className="delivery-note-info">
                                <div>
                                    <h3 className="delivery-note-fromto"><span className="highlight-text">From</span>:</h3>
                                    <p><strong><b>{selectedRow.billing_details.from_name}</b></strong></p>
                                    <p>{selectedRow.billing_details.from_address1}</p>
                                    <p>{selectedRow.billing_details.from_address2} , {selectedRow.billing_details.from_city}</p>
                                    <p>
                                        <strong>Phone:</strong> <strong><b>{selectedRow.billing_details.from_phone1}, {selectedRow.billing_details.from_phone2}</b></strong>
                                    </p>
                                </div>
                                <div>
                                    <h3 className="delivery-note-fromto"><span className="highlight-text">To</span>:</h3>
                                    <p><strong><b>{selectedRow.billing_details.to_name}</b></strong></p>
                                    <p>{selectedRow.billing_details.to_address1}</p>
                                    <p>{selectedRow.billing_details.to_address2} , {selectedRow.billing_details.to_city}</p>
                                    <p>
                                        <strong>Phone:</strong> <strong><b>{selectedRow.billing_details.to_phone1}, {selectedRow.billing_details.to_phone2}</b></strong>
                                    </p>
                                </div>
                            </div>

                            <div className="delivery-note-right-align">
                                <p><strong>Sir,</strong></p>
                                <div className="letter-content">
                                    <p><span className="highlight-text"><strong>Ref:</strong><strong><b> {selectedRow.ref_reg_no} </b></strong>/ {selectedRow.billing_details.ref_vehicle_type} {selectedRow.billing_details.ref_vehicle_color}</span></p>
                                    <p>
                                        I have this day purchased the above vehicle from you for the sum of Rs.<strong> <b>{selectedRow.billing_details.ref_amount}</b></strong> (Rupees in Words: <strong> {selectedRow.billing_details.ref_amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                    </p>
                                    <p>
                                        The entire risk is being bome by me / us / from this time <strong><b>{selectedRow.billing_details.ref_time}</b></strong>
                                    </p>
                                </div>
                            </div>

                            <div className="delivery-note-row">
                                {/* Left: Vehicle Details */}
                                <div className="delivery-note-vehicle-details">
                                    <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark>:</h3>
                                    <p><strong>Make:</strong><span>{selectedRow.billing_details.bike_make}</span></p>
                                    <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.bike_chase_no}</span></p>
                                    <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.bike_engine_no}</span></p>
                                </div>

                                {/* Right: Payment Details */}
                                <div className="delivery-note-payment">
                                    <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark>:</h3>
                                    <p><strong>1) Payment Type:</strong><span>{selectedRow.billing_details.cash_paid1} / {selectedRow.billing_details.payment_type1}</span></p>
                                    <p><strong>2) Payment Type:</strong><span>{selectedRow.billing_details.cash_paid2} / {selectedRow.billing_details.payment_type2}</span></p>
                                    <p><strong>Finance Details:</strong></p>
                                    <p><strong>Bank Name:</strong> <span>{selectedRow.billing_details.bank_name}</span></p>
                                    <p><strong>Finance:</strong><span> {selectedRow.billing_details.finance}</span></p>
                                </div>
                            </div>
                            <p><mark className="highlight-text"><strong>Received Documents:{" "}
                                {[
                                    selectedRow.billing_details.is_rc && "RC BOOK",
                                    selectedRow.billing_details.is_insurance && "INSURANCE COPY",
                                    selectedRow.billing_details.is_form_2930 && "FORM 29 & 30",
                                    selectedRow.billing_details.is_noc && "NOC"
                                ].filter(Boolean).join(", ")}
                            </strong></mark></p>
                            <div className="delivery-note-tamil-text">
                                <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                                <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                                <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                                <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                            </div>

                            <div className="delivery-note-signatures">
                                <div>
                                    <p>
                                        <strong>Signature of Buyer</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Stocks